exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".round-trip-type-container {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n@media (max-width: 576px) {\n  .round-trip-type-container {\n    display: block;\n  }\n}\n.round-trip-type-container .round-trip-type-item {\n  padding: 10px 20px 10px 10px;\n}\n", ""]);

// exports
